import React from 'react';
import { getImageUrl } from '../utils/imageUrl';

interface SubpageHeroProps {
  title: string;
  backgroundMedia?: {
    url: string;
    alternativeText?: string;
  };
  mediaType?: 'image' | 'video';
  videoUrl?: string;
  overlayOpacity?: number;
  textColor?: 'white' | 'black';
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
}

const SubpageHero: React.FC<SubpageHeroProps> = ({
  title,
  backgroundMedia,
  mediaType = 'image',
  videoUrl,
  overlayOpacity = 0.3,
  textColor = 'white',
  paddingBottom = 80,
  paddingLeft = 120,
  paddingRight = 120,
}) => {
  const containerStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    minHeight: '560px',
    height: 'auto',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    padding: '2rem 0',
  };

  const mediaStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
  };

  const overlayStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(0, 0, 0, ${overlayOpacity})`,
    zIndex: 2,
  };

  const contentStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 3,
    color: textColor,
    paddingBottom: `${paddingBottom}px`,
    paddingLeft: `${paddingLeft}px`,
    paddingRight: `${paddingRight}px`,
    maxWidth: '100%',
  };

  const titleStyle: React.CSSProperties = {
    fontFamily: 'var(--h1-font-family)',
    fontWeight: 'var(--h1-font-weight)',
    fontStyle: 'var(--h1-font-style)',
    fontSize: 'var(--h1-font-size)',
    lineHeight: 'var(--h1-line-height)',
    letterSpacing: 'var(--h1-letter-spacing)',
    margin: 0,
  };

  // Get the proper image URL
  const imageUrl = backgroundMedia?.url ? getImageUrl(backgroundMedia.url) : null;
  
  // Debug logging
  console.log('🖼️ SubpageHero - backgroundMedia:', backgroundMedia);
  console.log('🖼️ SubpageHero - imageUrl:', imageUrl);

  return (
    <div className="subpage-hero" style={containerStyle}>
      {/* Background Media */}
      {mediaType === 'video' && videoUrl ? (
        <video
          style={mediaStyle}
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={videoUrl} type="video/mp4" />
          {imageUrl && (
            <img
              src={imageUrl}
              alt={backgroundMedia?.alternativeText || 'Background'}
              style={mediaStyle}
            />
          )}
        </video>
      ) : (
        imageUrl && (
          <img
            src={imageUrl}
            alt={backgroundMedia?.alternativeText || 'Background'}
            style={mediaStyle}
          />
        )
      )}

      {/* Overlay */}
      <div style={overlayStyle}></div>

      {/* Content */}
      <div className="hero-content" style={contentStyle}>
        <h1 className="hero-title" style={titleStyle}>{title}</h1>
      </div>
    </div>
  );
};

export default SubpageHero; 